export default "__VITE_ASSET__BRNxNgMl__"